<template>
  <div id="basic-card" class="home-page">
    <div class="vx-row">
      <div class="loader-block loader-block2" v-if="axiosInstance">
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </div>
      <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0" v-if="$route.name === 'myLibrary'">My Library</h2>
      <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0" v-else-if="!isTagSearch">Library results</h2>
      <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0" v-else>
          Tag search ({{isTagSearch}}: '{{keywordSearch[isTagSearch].join(",")}}')  results:
      </h2>
      <div class="vx-col w-full" style="display: flex; justify-content: flex-end" v-if="totalItems">
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler" >
            <div
                      class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ getOrderByName() }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
                <vs-dropdown-item @click="changeOrderBy" v-if="searchQuery">
                    <span>Relevance</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="changeOrderBy('updatedAt', 'desc')">
                    <span>Newest</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="changeOrderBy('updatedAt', 'asc')">
                    <span>Oldest</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="changeOrderBy('title', 'asc')">
                    <span>A-Z</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="changeOrderBy('title', 'desc')">
                    <span>Z-A</span>
                </vs-dropdown-item>
            </vs-dropdown-menu>
        </vs-dropdown>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{(totalItems - currentPage * itemsPerPage > 0) ? (currentPage * itemsPerPage ) : totalItems }} of {{ totalItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="changePerPage(6)">
              <span>6</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changePerPage(12)">
              <span>12</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changePerPage(24)">
              <span>24</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changePerPage(36)">
              <span>36</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div class="vx-col custom-asset-card mb-base w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6" v-for="(item, index) in items" :key="index">
          <AssetItem :item="item" :show-images="showImages" :is-my-library="$route.name === 'myLibrary'"/>
      </div>
      <div class="pagination-block">
        <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-base" v-if="totalPages > 1"/>
      </div>
    </div>
    <div style="position: relative">
        <div class="loader-block" v-if="axiosInstance3" style="min-height: 100px">
            <div class="loading">
                <div class="effect-1 effects"></div>
                <div class="effect-2 effects"></div>
                <div class="effect-3 effects"></div>
            </div>
        </div>
        <div v-for="(media_item, t) in mediaItems" v-if="mediaItems && Object.keys(mediaItems).length" :key="t">
            <div class="vx-row"  v-for="(items, key) in media_item.data" :key="key" v-if="t == '3d' && Object.keys(items).length">
                <h3 class="w-full" style="margin: 0 0 20px 14px">{{ t + ' ' + key }}</h3>
                <div class="vx-col custom-asset-card mb-base w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6" v-for="(item, index) in items" :key="index">
                    <a
                            :href="item.target_link"
                            target="_blank"
                    >
                        <vx-card>
                            <div slot="no-body" class="card-img-block">
                                <div class="asset-img-section">
                                    <img :src="item.thumbnail ? item.thumbnail : $root.getDefaultThumbnail(item.asset_type)" alt="content-img" class="responsive card-img-top">
                                </div>
                                <vs-chip
                                        :color="item.asset_type === 'video' ? 'danger' : item.asset_type === 'image' ? 'success' : 'primary'"
                                        class="item-category">{{ t }}
                                </vs-chip>
                            </div>
                            <h5 class="mb-2">{{ item.name }}</h5>
                        </vx-card>
                    </a>
                </div>
                <div class="pagination-block pagination-block2">
                    <vs-button class="shadow-lg" color="primary" type="border" @click="loadMore(t, key)" style="margin-top: 5px;" v-if="media_item.p[key].currentPage < media_item.p[key].total_pages" :class="`${key}_${t}_btn`">More</vs-button>
                    <!--<vs-pagination :total="media_item.p[key].total_pages" :max="7" v-model="media_item.p[key].currentPage" class="mt-base" v-if="media_item.p[key].total_pages > 1"-->
                    <!--@change="handleMediaPaginationChange"></vs-pagination>-->
                </div>
            </div>
            <div v-for="(items, key) in media_item.data" :key="key" v-if="t != '3d'">
                <div class="vx-row" v-for="(child_items, key2) in items" v-if="Object.keys(child_items).length" :key="key2">
                    <h3 class="w-full" style="margin: 0 0 20px 14px">{{ t + ' ' + key + ' - ' +  key2 }}</h3>
                    <div class="vx-col custom-asset-card mb-base w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6" v-for="(item, index) in child_items" :key="index">
                        <a
                                :href="item.target_link"
                                target="_blank"
                        >
                            <vx-card>
                                <div slot="no-body" class="card-img-block">
                                    <div class="asset-img-section">
                                        <img :src="item.thumbnail ? item.thumbnail : $root.getDefaultThumbnail(item.asset_type)" alt="content-img" class="responsive card-img-top"  v-if="showImages">
                                    </div>
                                    <vs-chip
                                            :color="item.asset_type === 'video' ? 'danger' : item.asset_type === 'image' ? 'success' : 'primary'"
                                            class="item-category">{{ t }}
                                    </vs-chip>
                                </div>
                                <h5 class="mb-2">{{ item.name }}</h5>
                            </vx-card>
                        </a>
                    </div>
                    <div class="pagination-block pagination-block2">
                        <vs-button class="shadow-lg" color="primary" type="border" @click="loadMore(t, key, key2)" style="margin-top: 5px;" v-if="media_item.p[key][key2].currentPage < media_item.p[key][key2].total_pages" :class="`${key}_${t}_${key2}_btn`">More</vs-button>
                        <!--<vs-pagination :total="media_item.p[key][key2].total_pages" :max="7" v-model="media_item.p[key][key2].currentPage" class="mt-base" v-if="media_item.p[key][key2].total_pages > 1"-->
                        <!--@change="handleMediaPaginationChange"></vs-pagination>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import AssetItem from "../components/AssetItem";
    export default {
        name: 'Home',
        components: {AssetItem},
        head() {
            return {
                title: {
                    inner: 'AMP',
                    separator: ' ',
                    complement: ''
                },
                meta: [
                    {hid: 'description', name: 'description', content: ''}
                ]
            }
        },
        data() {
            return {
                orderBy: {
                    'order': 'desc',
                    'order_by': 'updatedAt'
                },
                searchQuery: '',
                axiosInstance: false,
                axiosInstance2: false,
                axiosInstance3: false,
                debounce: false,
                items: [],
                mediaItems: [],
                currentPage: 1,
                totalItems: 0,
                itemsPerPage: 24,
                totalPages: 0,
                isMounted: false,
                isMounted2: false,
                showImages: false,
                is_test: false,
                coobo_link_only: false,
                is_empty: false,
                is_recently: false,
                isTagSearch: false,
                keywordSearch: {
                    keywords: false,
                    partKeywords: false,
                    typeKeywords: false
                }
            }
        },
        computed: {},
        mounted() {
            this.$root.$on('update_search', (search) => {
                this.searchQuery = search;
                this.orderBy = search ? '' : {
                    'order': 'desc',
                    'order_by': 'updatedAt'
                };
                this.getSearchData();
            })
            this.$root.$on("clearSearch", () => {
                this.$store.commit("setState", {searchQuery: ""});
                this.searchQuery = "";
                this.orderBy = {
                    'order': 'desc',
                    'order_by': 'updatedAt'
                };
                this.search();
            });
            console.log(this.$route);
            ["partKeywords", "typeKeywords", "keywords"].forEach(k => {
                if (this.$route.query[k]) {
                    this.keywordSearch[k] = Array.isArray(this.$route.query[k]) ? this.$route.query[k] : [this.$route.query[k]];
                }
                if (this.keywordSearch[k].length) {
                    this.isTagSearch = k;
                }
            })
            if (this.$route.query.search) {
                this.searchQuery = this.$route.query.search;
            }
            if (this.$route.query.page) {
                this.currentPage = +this.$route.query.page;
            }
            if (this.$route.query.per_page) {
                this.itemsPerPage = +this.$route.query.per_page;
            }
            ["is_test", "is_empty", "is_recently", "coobo_link_only"].forEach(k => {
                if (this.$route.query[k]) {
                    this[k] = true
                }
            });
            Object.keys(this.$store.state.assetTypes).forEach(t => {
                if (this.$route.query[t]) {
                    this.$store.commit("setFilter", {key: t, value: true});
                }
            })
            if (this.$route.query.order && this.$route.query.order_by) {
                this.orderBy = {
                    order_by: this.$route.query.order_by,
                    order: this.$route.query.order
                };
            }
            this.search();
        },

        beforeDestroy(){
            this.$root.$off('update_search');
            this.$root.$off('clearSearch');
        },
        methods: {
            getOrderByName() {
                if (this.orderBy) {
                    if (this.orderBy.order_by == 'updatedAt') {
                        if (this.orderBy.order == 'asc') {
                            return 'Oldest'
                        } else {
                            return 'Newest'
                        }
                    } else {
                        if (this.orderBy.order == 'asc') {
                            return 'A-Z'
                        } else {
                            return 'Z-A'
                        }
                    }
                } else {
                    return 'Relevance';
                }
            },
            changeOrderBy(field, order, without_search) {
                if (field && order) {
                    this.orderBy = {
                        order_by: field,
                        order: order
                    };
                } else {
                    this.orderBy = null;
                }

                this.updateUrl();

                if (!without_search) {
                    setTimeout(() => {
                        this.search()
                    }, 10)
                }
            },
            getTypeName(item) {
                if (!item.asset_type) return "";
                return this.$store.state.assetTypes[item.asset_type] || "";
            },
            handlePaginationChange() {
                if (this.isMounted) {
                    this.items = [];
                    this.search();
                }
            },
            handleMediaPaginationChange(e) {
                if (this.isMounted2) {
                    this.getMediaData();
                }
            },
            updateUrl() {
                let path = this.$route.path;
                let qObj = {
                    per_page: this.itemsPerPage
                };
                ["is_test", "is_empty", "is_recently", "coobo_link_only"].forEach(k => {
                    if (this[k]) {
                        qObj[k] = true
                    }
                });
                Object.keys(this.$store.state.assetTypes).forEach(k => {
                    if (this.$store.state.typeFilters[k]) {
                        qObj[k.replace(" ", "_")] = true
                    }
                })
                if (this.orderBy && this.orderBy.order && this.orderBy.order_by) {
                    qObj.order_by = this.orderBy.order_by;
                    qObj.order = this.orderBy.order;
                }
                if (this.currentPage !== 1) {
                    qObj.page = this.currentPage;
                }
                if (this.$store.state.searchQuery) {
                    qObj.search = this.$store.state.searchQuery;
                }
                ["partKeywords", "typeKeywords", "keywords"].forEach(k => {
                    if ( this.keywordSearch[k]) {
                        qObj[k] = this.keywordSearch[k]
                    }
                })
                let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                let q = "?" + new URLSearchParams(qArr).toString()
                history.pushState(
                    {},
                    null,
                    path+q
                )
            },
            getSearchData() {
                this.currentPage = 1;
                this.search()
            },
            getMediaData() {
                const CancelToken = axios.CancelToken;
                const source3 = CancelToken.source();

                if (this.axiosInstance3) {
                    this.axiosInstance3.cancel();
                }
                let types = [];
                for (let k in this.$store.state.typeFilters) {
                    if (this.$store.state.typeFilters[k]) {
                        types.push(k)
                    }
                }

                if (!types.length) {
                    types = Object.keys(this.$store.state.typeFilters)
                }
                this.axiosInstance3 = source3;

                let url3 = '/assets/media-search' + '?asset_types=' + JSON.stringify(types);
                if (this.mediaItems && Object.keys(this.mediaItems).length) {
                    console.log(this.mediaItems)
                    let p = {};
                    for (let k in this.mediaItems) {
                        p[k] = this.mediaItems[k].p;
                    }
                    url3 += '&p=' + JSON.stringify(p)
                }
                url3 += '&search=' + this.searchQuery;

                this.$axios.get(url3, {cancelToken: source3.token}).then(res => {
                    this.mediaItems = res.data;
                    this.axiosInstance3 = false;
                    if (!this.isMounted) {
                        setTimeout(() => {
                            this.isMounted = true;
                        }, 200)
                    }
                    if (!this.isMounted2) {
                        setTimeout(() => {
                            this.isMounted2 = true;
                        }, 200)
                    }
                }).catch(e => {
                    this.axiosInstance = false;
                    this.axiosInstance3 = false;
                    console.log('catch_search', e)
                });
            },
            loadMore(type, key, key2) {
                console.log(type, key, key2)
                let p = 1;
                let id = '';
                if (key2) {
                    p = this.mediaItems[type].p[key][key2].currentPage;
                    id = '.' + key + '_' + type + '_' + key2 + '_btn';
                } else {
                    p = this.mediaItems[type].p[key].currentPage;
                    id = '.' + key + '_' + type + '_btn';
                }
                this.$root.addLoading(id);

                let url = '/assets/media-search/' + type + '?name=' + key + '&search=' + this.searchQuery;
                if (key2) {
                    url += '&sub_name=' + key2;
                }



                url += '&page=' + p;

                this.$axios.get(url).then(res => {
                    if (res.data && res.data.length) {
                        let mediaItems = this.mediaItems;
                        if (key2) {
                            mediaItems[type].data[key][key2].push(...res.data);
                            mediaItems[type].p[key][key2].currentPage += 1;
                        } else {
                            mediaItems[type].data[key].push(...res.data);
                            mediaItems[type].p[key].currentPage += 1;
                        }

                        this.mediaItems = mediaItems;
                        this.$root.removeLoading(id);
                    }
                }).catch(e => {
                    this.axiosInstance = false;
                    this.axiosInstance3 = false;
                    this.$root.removeLoading(id);

                    console.log('catch_search', e)
                });
            },
            search() {
                this.updateUrl();
                this.mediaItems = [];
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                const source2 = CancelToken.source();

                let url = `/assets${this.isTagSearch ? "" : "/search"}`;
                let qObj = {
                    _limit: this.itemsPerPage,
                    _start: (this.currentPage - 1) * this.itemsPerPage
                };
                if (this.$route.name === 'myLibrary') {
                    qObj.owner = this.$store.state.user.email;
                }

                if (this.searchQuery) {
                    qObj._search = this.searchQuery;
                }
                if (!this.searchQuery && !this.isTagSearch) {
                    ["is_test", "is_empty", "is_recently", "coobo_link_only"].forEach(k => {
                        if (this[k]) {
                            qObj[k] = true;
                        }
                    })
                }
                if (this.orderBy) {
                    qObj._sort = `${this.orderBy.order_by}:${this.orderBy.order}`
                }

                let types = [];
                for (let k in this.$store.state.typeFilters) {
                    if (this.$store.state.typeFilters[k]) {
                        types.push(k)
                    }
                }
                if (types.length > 0) {
                    qObj.asset_types = JSON.stringify(types);
                }
                ["partKeywords", "typeKeywords", "keywords"].forEach(k => {
                    if ( this.keywordSearch[k]) {
                        qObj[k] = this.keywordSearch[k]
                    }
                })
                let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                let q = "?" + new URLSearchParams(qArr).toString()
                url += q;
                if (this.axiosInstance) {
                    this.axiosInstance.cancel();
                }
                this.showImages = false;
                this.axiosInstance = source;

                this.$axios.get(url, {cancelToken: source.token}).then(res => {
                    this.items = res.data;
                    this.axiosInstance = false;
                    setTimeout(() => {
                        this.showImages = true;
                    }, 100)
                    if (this.searchQuery && res.data.length < 10 && this.$route.name !== 'myLibrary') {
                        this.getMediaData();
                    } else {
                        this.isMounted2 = false;

                        if (!this.isMounted) {
                            setTimeout(() => {
                                this.isMounted = true;
                            }, 200)
                        }
                    }
                }).catch(e => {
                    this.axiosInstance = false;
                    setTimeout(() => {
                        this.showImages = true;
                    }, 100)
                    this.axiosInstance3 = false;
                    console.log('catch_search', e)
                });

                let url2 = `/assets${this.isTagSearch ? "/count" : "/adv-search"}`
                delete qObj._sort;
                delete qObj._limit;
                delete qObj._start;
                qObj.isCountRequest = true;
                qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                q = "?" + new URLSearchParams(qArr).toString()
                url2 += q;
                if (this.axiosInstance2) {
                    this.axiosInstance2.cancel();
                }
                this.axiosInstance2 = source2;
                this.$axios.get(url2, {cancelToken: source2.token}).then(res => {
                    this.totalItems = res.data;
                    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
                    this.axiosInstance2 = false;
                }).catch(e => {
                    console.log('catch_search', e)
                })
            },
            changePerPage(limit) {
                this.itemsPerPage = limit;
                setTimeout(() => {
                    this.search()
                }, 10)
            }
        },
        watch: {
              currentPage: function() {
                this.handlePaginationChange()
              },
            axiosInstance: function() {
                if (this.axiosInstance === false && this.axiosInstance2 === false) {
                    this.$root.$emit('search_loading', false);
                }
            },
            axiosInstance2: function() {
                if (this.axiosInstance === false && this.axiosInstance2 === false) {
                    this.$root.$emit('search_loading', false);
                }
            },
        },
    }
</script>

<style lang="scss">
  #demo-basic-card {
    .overlay-card {
      .vx-card__collapsible-content {
        max-height: 485px;
      }
    }

    .chat-card-log {
      height: 360px;

      .chat-sent-msg {
        background-color: #f2f4f7 !important;
      }
    }

    .card-video {
      .video-js {
        height: 370px;
      }
    }
  }
</style>
